export default __webpack_public_path__ + "static/media/home_logo.a9ae2328.png";